import { render } from "./SwitchLanguage.vue?vue&type=template&id=63ebc5e1&scoped=true"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js"

import "./SwitchLanguage.vue?vue&type=style&index=0&id=63ebc5e1&scoped=true&lang=css"

import exportComponent from "/Users/rithy/Documents/code/vpos.club/vpos-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ebc5e1"]])

export default __exports__